import { render, staticRenderFns } from "./monthMBTable.vue?vue&type=template&id=0d047198&scoped=true&"
import script from "./monthMBTable.vue?vue&type=script&lang=js&"
export * from "./monthMBTable.vue?vue&type=script&lang=js&"
import style0 from "./monthMBTable.vue?vue&type=style&index=0&id=0d047198&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d047198",
  null
  
)

export default component.exports